import useGame from "../../game/hooks/use-game";

export default function useTasks() {
    const { tasks } = useGame();

    const isLoading = false;

    return {
        isLoading,
        tasks
    }
}
